import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import logo4 from '../../images/logo4.png';
import Pic3 from '../../images/Pic3.jpeg';
import Pic4 from '../../images/Pic4.jpg';
import CustomerTrackingModal from './CustomerTrackingModal';
import { getAllTrackings } from '../../redux/actions/customer/CustomerAction';
import { connect } from 'react-redux';
const CustomerTracking = ({trackings,getAllTrackings,id}) =>  {

    const params=useParams();

    const [rows, setRows] = useState([]);
    const [show, setShow] = useState(false);
    useEffect(() => {
        console.log(rows);
        if(trackings && trackings.length === 0) {
            getAllTrackings(params.customerId);
        } else if(trackings && trackings.length > 1) {
            console.log(trackings);
            // setRows(trackings.products);
            const products=[];
            trackings.map((tracking)=> products.push(...tracking.products));
            setRows(products);
        } 
    }, [trackings]);

    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => setShow(true);

    function handleOpenTracking(){
        getAllTrackings(params.customerId);
        handleShow();
    }

    function handleOrderProduct(){
        window.location=`/customer/${id}/products`;
        
    }
    const handleSubmit=()=>{
        window.location=`/tracking/${id}`;
    };
    return (
        <>
            <div className="row justify-content-evenly row-cols-2 g-2">
                <div className="col" style={{width: '18rem'}}>
                    <img src={Pic4} className='card-img-top' alt="image here"/>
                    <div className='card-body'>
                        <h5 className='card-title'>All Ordered Products</h5>
                        <center>
                            <button className='btn btn-success' onClick={()=>handleOpenTracking()}>View Product List</button>
                        </center>
                    </div>
                </div>

                <div className="col" style={{width: '18rem'}}>
                    <img src={Pic3} className='card-img-top' alt="image here"/>
                    <div className='card-body'>
                        <h5 className='card-title'>Get Tracking Status</h5>
                        <center>
                            <button className='btn btn-success' onClick={handleSubmit}>Tracking</button>
                        </center>
                    </div>
                </div>
                <div className="col" style={{width: '18rem'}}>
                    <img src={logo4} className='card-img-top' alt="image here"/>
                    <div className='card-body'>
                        <h5 className='card-title'>Order Product</h5>
                        <center>
                            <button className='btn btn-success' onClick={handleOrderProduct}>Order Product</button>
                        </center>
                    </div>
                </div>
                <CustomerTrackingModal show={show} handleClose={handleClose} data={rows} />
            </div>
        </>
    );
};


const mapStateToProps = (state) => {
    console.log('state', state);
    return {
        trackings: state.customers.tracking,
    };
};

const mapDispatchToProps = {
    getAllTrackings
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTracking);

